export default __webpack_public_path__ + "static/media/hamilton.b7a75864.webp";